var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6104 16.2789C30.6104 15.1946 30.5131 14.152 30.3324 13.1511H15.9307V19.0661H24.1602C23.8057 20.9775 22.7284 22.597 21.1089 23.6813V27.5181H26.0508C28.9423 24.856 30.6104 20.9358 30.6104 16.2789Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9306 31.2227C20.0593 31.2227 23.5207 29.8534 26.0507 27.518L21.1088 23.6813C19.7395 24.5988 17.988 25.1409 15.9306 25.1409C11.9479 25.1409 8.57681 22.451 7.37435 18.8367H2.26562V22.7985C4.78176 27.7961 9.95304 31.2227 15.9306 31.2227Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37482 18.8366C7.06899 17.9191 6.89523 16.939 6.89523 15.9312C6.89523 14.9234 7.06899 13.9433 7.37482 13.0258V9.06396H2.2661C1.23045 11.1283 0.639648 13.4637 0.639648 15.9312C0.639648 18.3987 1.23045 20.7341 2.2661 22.7984L7.37482 18.8366Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9306 6.72171C18.1756 6.72171 20.1913 7.49323 21.7761 9.00847L26.1619 4.62261C23.5137 2.15513 20.0523 0.639893 15.9306 0.639893C9.95304 0.639893 4.78176 4.06656 2.26562 9.06407L7.37435 13.0259C8.57681 9.41161 11.9479 6.72171 15.9306 6.72171Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.544bf24d16cb4d951192a2d43fa66885.svg";
export { ForwardRef as ReactComponent };